export const FIELDS_MENU = {
  PERSONAL: 'personal',
  PASSPORT: 'passport',
  ORGANIZATION: 'organization',
  TRANSPORT: 'transport',
  MY_REPRESENTATIVES: 'my-representatives',
  REPRESENTATIVE: 'representative',
};
